import styled from '@emotion/styled';
import { device } from './device';
import css from '@emotion/css';

interface IStyledImage {
  aspectratio?: string;
  borderRadius?: string;
  size?: string;
  margin?: string;
  type?: string;
}

export const StyledImage = styled.img`    
    aspect-ratio: ${(props: IStyledImage) => props.aspectratio};
    border-radius: ${(props: IStyledImage) => props.size === 'small' && '8px' || props.size === 'large' && '20px' || '8px'};
    display: block;
    width: ${(props: IStyledImage) => props.size === 'large' && '542px' || props.size === 'small' && '252px' || ''};
    height: ${(props: IStyledImage) => props.size === 'large' && '417pxpx' && ''};

    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
      width: ${(props: IStyledImage) => props.size === 'large' && '100%' || props.size === 'small' && '92px' || ''};
      height: ${(props: IStyledImage) => props.size === 'large' && '100%' || props.size === 'small' && '68px' || ''};
      border-radius: ${(props: IStyledImage) => props.size === 'small' && '8px' || props.size === 'large' && '12px' || '12px'};
    }

  ${(props: IStyledImage) => props.type == "nonprime" && css`
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
      /* border-radius: 0;
      margin-left:-24px;
      margin-right:-24px;
      max-width: -webkit-fill-available; */
    }
  `}

  ${(props: IStyledImage) => props.type == "perpetualsidebarthumbnail" && css`
    width: 92px;
    height: 72px;
  `}

`

export const Picture = styled.picture`
    overflow:hidden;
    flex-shrink: 0;
    display: flex;
    border-radius: ${(props: IStyledImage) => props.size === 'small' && '8px' || props.size === 'large' && '20px'};
    aspect-ratio: ${(props: IStyledImage) => props.aspectratio === 'small' && 16 / 9 || props.aspectratio === 'large' && 16 / 9}
`

export const ImageCaption = styled.div`
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  color: #595959;
  margin: ${(props: IStyledImage) => props.margin};

`